import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ServiceNav from "../../components/ServiceNav";

function Annuities() {
  return (
    <>
      <Header />
      <main>
        <section class="tp-hero-area p-relative">
          <div class="tp-hero-wrapper-slider">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide pt-20 pb-150 tp-hero-bg-image"
                  data-bg-color="#20536d"
                >
                  <img
                    class="tp-hero-bg"
                    src="../assets/images/banner-bg.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="tp-service-details-area pt-120 pb-120">
          <div class="container">
            <div class="row">
              <div class="col-lg-4">
                <div class="tp-service-widget">
                  <div class="tp-service-widget-item mb-40">
                    <ServiceNav activePath="/Annuities" />
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="tp-service-details-wrapper">
                  <h3 class="tp-service-details-title">
                    Retirement Income & Annuity Solutions
                  </h3>

                  <div class="tp-postbox-list mr-40">
                    <p>
                      Retirement should bring peace of mind — not financial
                      uncertainty.
                    </p>
                    <p>
                      At <strong>Kubera Financial Services</strong>, we help
                      clients explore annuity and retirement income strategies
                      designed to provide long-term financial stability and
                      confidence.
                    </p>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">We help with:</h2>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Fixed Annuities
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Indexed Annuities
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Retirement Income
                        Planning
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Principal Protection
                        Strategies
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Tax-Deferred Growth
                        Opportunities
                      </h4>
                      <h4 class="tp-postbox-list-title">
                        <i class="fa-regular fa-check"></i> Lifetime Income
                        Options
                      </h4>
                    </div>
                  </div>

                  <div class="tp-service-details-thumb">
                    <img src="../assets/images/s1.jpeg" alt="" />
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        What Is an Annuity?
                      </h2>
                      <p>
                        An annuity is a financial product designed to help
                        individuals grow retirement savings and create
                        predictable income streams for the future.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        Depending on your goals, annuities may offer:
                      </h3>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Guaranteed income
                        options
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Protection from
                        market downturns
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Tax-deferred
                        accumulation
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Long-term retirement
                        security
                      </h4>
                    </div>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        Planning for the Future
                      </h2>
                      <p>
                        Retirement planning is not just about saving money —
                        it’s about creating a strategy that helps protect your
                        lifestyle and financial independence.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        We work with clients to:
                      </h3>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Understand
                        retirement goals
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Evaluate risk
                        tolerance
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Explore income
                        strategies
                      </h4>
                      <h4 class="tp-service-details-subtitle-3">
                        <i class="fa-regular fa-check"></i> Build long-term
                        financial confidence
                      </h4>
                    </div>
                  </div>

                  <div class="tp-postbox-list-wrapper">
                    <div class="tp-postbox-list mr-40">
                      <h2 class="tp-postbox-list-title-1">
                        Independent Guidance You Can Trust
                      </h2>
                      <p>
                        As an independent agency, we help compare multiple
                        options to find strategies aligned with your financial
                        objectives and retirement goals.
                      </p>
                      <p>
                        Let us help you prepare for a more confident retirement.
                      </p>
                    </div>
                  </div>

                  <div class="tp-service-bg tp-service-details-box-2 tp-service-details-box-4 d-flex mb-40">
                    <div class="tp-service-details-box-content mr-30">
                      <h3 class="tp-service-details-subtitle-2">
                        We offer free consultation
                      </h3>
                      <p>
                        Schedule your free consultation today and let us help
                        you find the right coverage.
                      </p>

                      <h6>Please reach us for free consultation!</h6>
                      <Link class="tp-btn-service" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
export default Annuities;
